export default __webpack_public_path__ + "static/media/ebike3.65dffeac.png";